import { CommonUtilsServiceInterface } from 'domain/services';
import { GetLastProductVersionsUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getLastProductVersions: GetLastProductVersionsUseCaseInterface;
}

export class CommonUtilsService implements CommonUtilsServiceInterface {
  private readonly _getLastProductVersions: GetLastProductVersionsUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getLastProductVersions = usecases.getLastProductVersions;
  }

  async getLastProductVersions(
    params: GetLastProductVersionsUseCaseInterface.Params,
  ): Promise<GetLastProductVersionsUseCaseInterface.Result> {
    return this._getLastProductVersions.execute(params);
  }
}
